const show = ({ context, tag = 'div', status, message = 'Ocorreu um erro. Tente novamente' }) => {
  const isError = status === 'error'
  const response = document.querySelector('.o-response')

  if (response) {
    response.innerHTML = message

    if (!isError) return
    response.classList.add('s-head-shake')
    rmErrorAnimation(response)
    return
  }

  const reference = context.querySelector('button[type="submit"]')
  reference.insertAdjacentHTML(
    'afterend',
    `<${tag} class="o-text u-color-black-700 u-tl o-response ${isError ? 'has-error s-head-shake' : ''}" data-cy="messenger" aria-live="assertive">${message}</${tag}>`
  )

  if (!isError) return
  rmErrorAnimation()
}

const close = (context) => {
  const response = context.querySelector('.o-response')
  if (response) response.remove()
}

const rmErrorAnimation = (
  target = document.querySelector('.o-response')
) => {
  setTimeout(() => {
    target.classList.remove('s-head-shake')
  }, 400)
}

export default { show, close }
